var map = {
	"./aave-balances.json": 37539,
	"./balancer-balances.json": 15176,
	"./compound-balances.json": 77109,
	"./curve-balances.json": 88143,
	"./dodo-balances.json": 39185,
	"./frax-balances.json": 50235,
	"./instadapp-balances.json": 49650,
	"./lido-balances.json": 49824,
	"./yearn-balances.json": 32103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61229;